
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iVuad", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8kTwy = parcelRequire("8kTwy");




parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $h7YX1 = parcelRequire("h7YX1");


var $a6IPc = parcelRequire("a6IPc");


var $iNP4c = parcelRequire("iNP4c");


var $lAFHW = parcelRequire("lAFHW");


var $iJUOw = parcelRequire("iJUOw");


var $2v0M9 = parcelRequire("2v0M9");


var $aamGC = parcelRequire("aamGC");


var $0JTlo = parcelRequire("0JTlo");


var $hWVhC = parcelRequire("hWVhC");


var $1xVJk = parcelRequire("1xVJk");


var $mSdG9 = parcelRequire("mSdG9");


var $cgtv4 = parcelRequire("cgtv4");

const $233f78e62ed7ba05$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    confluenceAfterUpgradeAIStandardModalTitle: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.title",
        defaultMessage: "Welcome to Standard"
    },
    confluenceAfterUpgradeAIStandardModalSubtitle: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.subtitle",
        defaultMessage: "You successfully unlocked new ways to create, organize, and discover content with the help of AI"
    },
    confluenceAfterUpgradeAIStandardModalPrimaryCTA: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.primary-cta",
        defaultMessage: "Get started"
    },
    confluenceAfterUpgradeAIStandardModalSecondaryCTA: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.secondary-cta",
        defaultMessage: "Close"
    },
    confluenceAfterUpgradeAIStandardModalAIDraft: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.ai-draft",
        defaultMessage: "Ask AI to draft pages and improve writing"
    },
    confluenceAfterUpgradeAIStandardModalAISummaries: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.ai-summaries",
        defaultMessage: "Catch up on pages by generating a summary"
    },
    confluenceAfterUpgradeAIStandardModalAIContextualInfo: {
        id: "@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.ai-standard-modal.ai-contextual-info",
        defaultMessage: "Find contextual and reliable information with AI"
    }
});


const $1ac42967dc0afcbf$export$38ccae318ce089cf = ({ onInteractionComplete: onInteractionComplete })=>{
    const intl = (0, $8C5kA.default)();
    const { isOpen: isOpen, handleClose: handleClose } = (0, $0JTlo.useModalState)();
    const componentAttributes = {
        product: 'confluence',
        offerShown: 'AI',
        modalShownPrePostUpgrade: 'POST_UPGRADE'
    };
    const { clickedDismissModal: clickedDismissModal, clickedPrimaryCTAOnModal: clickedPrimaryCTAOnModal } = (0, $2v0M9.useAnalytics)();
    const handlePrimaryCTAClick = (e)=>{
        e?.preventDefault();
        clickedPrimaryCTAOnModal((0, $aamGC.CONFLUENCE_AFTER_STANDARD_UPGRADE_AI_MODAL), componentAttributes);
        handleClose();
        onInteractionComplete();
    };
    const handleDismissModal = (dismissalMethod)=>{
        clickedDismissModal((0, $aamGC.CONFLUENCE_AFTER_STANDARD_UPGRADE_AI_MODAL), {
            ...componentAttributes,
            dismissalMethod: dismissalMethod
        });
        handleClose();
        onInteractionComplete();
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $iJUOw.Modal), {
        height: "560px",
        logo: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceLogo), {
            shouldUseNewLogoDesign: true,
            size: "xsmall"
        }),
        title: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalTitle),
        subtitle: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalSubtitle),
        testId: "growth-pattern-library-modal",
        includeCloseButton: true,
        onClose: ()=>{
            handleDismissModal('modalOverlayClick');
        },
        sideContent: /*#__PURE__*/ (0, $l998X.jsx)((0, $hWVhC.StandardOfferAIModalRightSide), {}),
        actions: /*#__PURE__*/ (0, $l998X.jsx)((0, $mSdG9.PrimaryAndSecondaryCTAActionsGroup), {
            onPrimaryCTAClick: handlePrimaryCTAClick,
            onSecondaryCTAClick: ()=>handleDismissModal('secondaryCTAButton'),
            primaryCTALabel: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalPrimaryCTA),
            secondaryCTALabel: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalSecondaryCTA)
        }),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1xVJk.EditionHighlightsLeftContent), {
                highlights: [
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))),
                        title: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalAIDraft)
                    },
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))),
                        title: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalAISummaries)
                    },
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iNP4c))),
                        title: intl.formatMessage((0, $233f78e62ed7ba05$export$defe85febe8b728c).confluenceAfterUpgradeAIStandardModalAIContextualInfo)
                    }
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2v0M9.ScreenEvent), {
                name: "upgradeFreePoolTargetExperimentModal",
                attributes: componentAttributes
            })
        ]
    });
};


const $8f837e359ee131cc$export$ddc188f394bddd0c = ({ storageAdapter: storageAdapter })=>{
    const modalToShow = (0, $8kTwy.getPostUpgradeModalToShowForUpgradeFreePoolTargetExperiment)(storageAdapter, (0, $8kTwy.Product).Confluence);
    const cleanExperimentLocalStorageAttributes = ()=>{
        storageAdapter.removeItem((0, $8kTwy.STORAGE_KEYS).Confluence.first);
        storageAdapter.removeItem((0, $8kTwy.STORAGE_KEYS).Confluence.second);
    };
    switch(modalToShow){
        case (0, $8kTwy.UpgradeModalComponent).ConfluenceAfterStandardUpgradeAIModal:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $1ac42967dc0afcbf$export$38ccae318ce089cf), {
                onInteractionComplete: cleanExperimentLocalStorageAttributes
            });
        case (0, $8kTwy.UpgradeModalComponent).None:
        default:
            return null;
    }
};



var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $17wUi = parcelRequire("17wUi");


var $a7QKb = parcelRequire("a7QKb");

const $4f5a49218ecce596$export$4c71be9b3a5cb00 = ()=>{
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    // Audience is only eligible to see this experiment modal if they have upgraded to Confluence Standard edition
    if (!cloudId || !edition || edition !== (0, $euL71.ConfluenceEdition).STANDARD) return null;
    const confluenceStorageAdapter = {
        get: (key)=>{
            return (0, $17wUi.confluenceLocalStorageInstance).getItem(key);
        },
        set: (key, value)=>{
            (0, $17wUi.confluenceLocalStorageInstance).setItem(key, value);
        },
        removeItem: (key)=>{
            (0, $17wUi.confluenceLocalStorageInstance).removeItem(key);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a7QKb.ExperimentErrorBoundaryWrapper), {
        experimentKey: "twcg-206_confluence_upgrade_permanent_free",
        source: "UpgradeFreePoolExperimentModalPostUpgradeModalBaseComponent",
        cohort: "variation" // Post-upgrade users are always in the variation cohort
        ,
        additionalAttributes: {
            cloudId: cloudId,
            edition: edition
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8f837e359ee131cc$export$ddc188f394bddd0c), {
        storageAdapter: confluenceStorageAdapter
    }));
};
module.exports["UpgradeFreePoolExperimentModalPostUpgradeModalBaseComponent"] = $4f5a49218ecce596$export$4c71be9b3a5cb00;

});

parcelRegister("h7YX1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7825eb38d10cf15$var$_react = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7825eb38d10cf15$var$_baseNew = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7825eb38d10cf15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7825eb38d10cf15$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $c7825eb38d10cf15$var$_react.default.createElement($c7825eb38d10cf15$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$c7825eb38d10cf15$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $c7825eb38d10cf15$var$_default = module.exports.default = $c7825eb38d10cf15$var$AiGenerativeTextIcon;

});

parcelRegister("iJUOw", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8TTLA = parcelRequire("8TTLA");

var $8CZUH = parcelRequire("8CZUH");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $bWLcG = parcelRequire("bWLcG");


var $59OcG = parcelRequire("59OcG");


var $4gAvD = parcelRequire("4gAvD");


var $lJwTu = parcelRequire("lJwTu");

const $a38eaca20b61fcf5$var$hasSideContentContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    overflowY: 'auto',
    height: '100%',
    borderRadius: 'radius.small',
    [(0, $bWLcG.media).above.sm]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr'
    }
});
const $a38eaca20b61fcf5$var$baseContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $a38eaca20b61fcf5$var$stack = (0, $ecnYn.xcss)({
    height: '100%',
    padding: 'space.600',
    overflowY: 'auto'
});
const $a38eaca20b61fcf5$var$sideContainer = (0, $ecnYn.xcss)({
    display: 'none',
    [(0, $bWLcG.media).above.sm]: {
        backgroundColor: 'color.background.accent.gray.subtlest',
        display: 'flex',
        width: '100%',
        overflowY: 'auto'
    }
});
const $a38eaca20b61fcf5$var$leftSideContainer = (0, $ecnYn.xcss)({
    [(0, $bWLcG.media).above.sm]: {
        borderTopLeftRadius: 'radius.small',
        borderBottomLeftRadius: 'radius.small'
    }
});
const $a38eaca20b61fcf5$var$rightSideContainer = (0, $ecnYn.xcss)({
    [(0, $bWLcG.media).above.sm]: {
        borderTopRightRadius: 'radius.small',
        borderBottomRightRadius: 'radius.small'
    }
});
const $a38eaca20b61fcf5$var$closeButtonStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.200',
    right: 'space.200',
    zIndex: '1'
});
const $a38eaca20b61fcf5$export$2b77a92f1a5ad772 = ({ logo: logo, title: title, subtitle: subtitle, children: children, actions: actions, right: right, sideContent: sideContent, sideLocation: sideLocation = 'right', renderedInsideEntrypoint: renderedInsideEntrypoint, backgroundColor: backgroundColor, includeCloseButton: includeCloseButton = false, ...modalProps })=>{
    const hasSideContent = !!right || !!sideContent;
    const rightContent = right ?? (sideLocation === 'right' ? sideContent : undefined);
    const leftContent = !right && sideLocation === 'left' ? sideContent : undefined;
    const safeOnClose = typeof modalProps.onClose === 'function' ? modalProps.onClose : ()=>{};
    if (renderedInsideEntrypoint) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $a38eaca20b61fcf5$var$baseContainerStyles,
            hasSideContent ? $a38eaca20b61fcf5$var$hasSideContentContainerStyles : undefined
        ],
        backgroundColor: backgroundColor,
        style: {
            height: modalProps.height
        },
        children: [
            includeCloseButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $a38eaca20b61fcf5$var$closeButtonStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                    testId: "modal-close-button",
                    onClick: safeOnClose
                })
            }),
            !!leftContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $a38eaca20b61fcf5$var$sideContainer,
                    $a38eaca20b61fcf5$var$leftSideContainer
                ],
                children: leftContent
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                space: "space.400",
                xcss: $a38eaca20b61fcf5$var$stack,
                children: [
                    logo,
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                        space: "space.200",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $lJwTu.ModalTitle), {
                                children: title
                            }),
                            subtitle ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                color: "color.text.subtle",
                                size: "medium",
                                children: subtitle
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $59OcG.ModalBody), {
                        children: children
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4gAvD.ModalFooter), {
                        children: actions
                    })
                ]
            }),
            !!rightContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $a38eaca20b61fcf5$var$sideContainer,
                    $a38eaca20b61fcf5$var$rightSideContainer
                ],
                children: rightContent
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
        width: hasSideContent ? 'x-large' : undefined,
        ...modalProps,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: [
                $a38eaca20b61fcf5$var$baseContainerStyles,
                hasSideContent ? $a38eaca20b61fcf5$var$hasSideContentContainerStyles : undefined
            ],
            backgroundColor: backgroundColor,
            children: [
                includeCloseButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $a38eaca20b61fcf5$var$closeButtonStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                        testId: "modal-close-button",
                        onClick: safeOnClose
                    })
                }),
                !!leftContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: [
                        $a38eaca20b61fcf5$var$sideContainer,
                        $a38eaca20b61fcf5$var$leftSideContainer
                    ],
                    children: leftContent
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                    space: "space.400",
                    xcss: $a38eaca20b61fcf5$var$stack,
                    children: [
                        logo,
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                            space: "space.200",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $lJwTu.ModalTitle), {
                                    children: title
                                }),
                                subtitle ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                    color: "color.text.subtle",
                                    size: "medium",
                                    children: subtitle
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $59OcG.ModalBody), {
                            children: children
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $4gAvD.ModalFooter), {
                            children: actions
                        })
                    ]
                }),
                !!rightContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: [
                        $a38eaca20b61fcf5$var$sideContainer,
                        $a38eaca20b61fcf5$var$rightSideContainer
                    ],
                    children: rightContent
                })
            ]
        })
    });
};
module.exports["Modal"] = $a38eaca20b61fcf5$export$2b77a92f1a5ad772;

});

parcelRegister("59OcG", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $crya1 = parcelRequire("crya1");


var $804cB = parcelRequire("804cB");


var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");

const $4494e4f87dd19321$var$container = (0, $ecnYn.xcss)({
    flex: '1 1 auto',
    overflowY: 'auto'
});
const $4494e4f87dd19321$export$cb540d8b0ef7906c = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $crya1.TouchScrollable), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
            space: "space.300",
            xcss: $4494e4f87dd19321$var$container,
            testId: testId,
            children: children
        })
    });
};
module.exports["ModalBody"] = $4494e4f87dd19321$export$cb540d8b0ef7906c;

});

parcelRegister("4gAvD", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $804cB = parcelRequire("804cB");


var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");

const $f0cb77ae0ad3836b$var$wrapStyles = (0, $ecnYn.xcss)({
    flexWrap: 'wrap-reverse'
});
const $f0cb77ae0ad3836b$export$519437715052e656 = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        alignInline: "end",
        testId: testId,
        space: "space.150",
        xcss: $f0cb77ae0ad3836b$var$wrapStyles,
        children: children
    });
};
module.exports["ModalFooter"] = $f0cb77ae0ad3836b$export$519437715052e656;

});

parcelRegister("lJwTu", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $7hXDW = parcelRequire("7hXDW");


var $804cB = parcelRequire("804cB");

const $b97fbf5d6df63832$export$b26fae16ba5468aa = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
        testId: testId,
        size: "large",
        id: titleId,
        children: children
    });
};
module.exports["ModalTitle"] = $b97fbf5d6df63832$export$b26fae16ba5468aa;

});

parcelRegister("cOrQJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8z9j5 = parcelRequire("8z9j5");


var $60yhz = parcelRequire("60yhz");

/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $3ebd34920f1cc52c$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $42omo.useState)((0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        const observer = new (0, $60yhz.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $3ebd34920f1cc52c$export$2e2bcd8739ae039 = $3ebd34920f1cc52c$var$useThemeObserver;
module.exports["default"] = $3ebd34920f1cc52c$export$2e2bcd8739ae039;

});

parcelRegister("8hmrm", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $gvWCD = parcelRequire("gvWCD");


var $3HIy9 = parcelRequire("3HIy9");


var $39G0n = parcelRequire("39G0n");

const $31b517e9b4290477$export$8c06ae8e7f403dea = ({ product: product, team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, additionalAttributes: additionalAttributes = {} }, isActiveExperiment = true)=>{
    (0, $39G0n.validateExperimentName)(experimentMeta.experimentKey);
    const eventPayload = (0, $gvWCD.createEventPayload)({
        team: team,
        experimentMeta: experimentMeta,
        errorType: errorType,
        errorMessage: errorMessage,
        source: source,
        severity: severity,
        isActiveExperiment: isActiveExperiment,
        additionalAttributes: additionalAttributes,
        product: product
    });
    switch(product){
        case (0, $gwZbZ.Product).ADMIN_HUB:
            return {
                data: eventPayload
            };
        case (0, $gwZbZ.Product).JIRA:
            return {
                data: eventPayload,
                productSpecificRules: {
                    jira: {
                        createAnalyticsEventPayload: (0, $3HIy9.convertEventPayloadForJiraCreateAnalyticsEvent)({
                            data: eventPayload
                        }),
                        fireEventPayload: (0, $3HIy9.convertEventAttributesForJiraFireEvent)({
                            data: eventPayload
                        })
                    }
                }
            };
        case (0, $gwZbZ.Product).CONFLUENCE:
            return {
                type: (0, $gwZbZ.CONFLUENCE_OPERATIONAL_EVENT_TYPE),
                data: eventPayload
            };
        default:
            throw new Error(`Unsupported product: ${product}`);
    }
};
module.exports["createProductSpecificAnalyticsIntegrationPayload"] = $31b517e9b4290477$export$8c06ae8e7f403dea;

});

parcelRegister("gwZbZ", function(module, exports) {
const $64e202edaa8eb03b$export$ec4825154d679381 = 'error';
const $64e202edaa8eb03b$export$a924d1f92c0e2e78 = 'growth-experiment';
const $64e202edaa8eb03b$export$e5025d93161b0712 = 'sendOperationalEvent';
const $64e202edaa8eb03b$export$5c3e8a6b8e7ba45b = 'growth-error-analytics';
var $64e202edaa8eb03b$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["JIRA"] = "jira";
    Product["CONFLUENCE"] = "confluence";
    Product["ADMIN_HUB"] = "admin-hub";
    return Product;
}({});
var $64e202edaa8eb03b$export$dba1278861bf0dc1 = /*#__PURE__*/ function(ErrorType) {
    ErrorType["GRAPHQL"] = "graphql";
    ErrorType["REST"] = "rest";
    ErrorType["ERROR_BOUNDARY"] = "error-boundary";
    ErrorType["GENERIC"] = "generic";
    return ErrorType;
}({});
var $64e202edaa8eb03b$export$918a9776c0a3cf27 = /*#__PURE__*/ function(Severity) {
    Severity["LOW"] = "low";
    Severity["MEDIUM"] = "medium";
    Severity["HIGH"] = "high";
    return Severity;
}({});
const $64e202edaa8eb03b$export$a61493d7ab73936 = 'growth';
module.exports["ERROR_ACTION"] = $64e202edaa8eb03b$export$ec4825154d679381;
module.exports["ERROR_ACTION_SUBJECT"] = $64e202edaa8eb03b$export$a924d1f92c0e2e78;
module.exports["CONFLUENCE_OPERATIONAL_EVENT_TYPE"] = $64e202edaa8eb03b$export$e5025d93161b0712;
module.exports["Product"] = $64e202edaa8eb03b$export$264ad599d7cef668;
module.exports["ErrorType"] = $64e202edaa8eb03b$export$dba1278861bf0dc1;
module.exports["Severity"] = $64e202edaa8eb03b$export$918a9776c0a3cf27;
module.exports["EVENT_TAG_GROWTH"] = $64e202edaa8eb03b$export$a61493d7ab73936;

});

parcelRegister("gvWCD", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");

const $d2a9f5f63821177b$export$f2a94361d01a626c = ({ team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, isActiveExperiment: isActiveExperiment, product: product, additionalAttributes: additionalAttributes = {} })=>{
    const actionSubjectId = `${(0, $gwZbZ.ERROR_ACTION_SUBJECT)}-${experimentMeta.experimentKey}-${errorType}`;
    return {
        action: (0, $gwZbZ.ERROR_ACTION),
        actionSubject: (0, $gwZbZ.ERROR_ACTION_SUBJECT),
        actionSubjectId: actionSubjectId,
        source: experimentMeta.experimentKey,
        attributes: {
            errorType: errorType,
            team: team,
            experimentKey: experimentMeta.experimentKey,
            cohort: experimentMeta?.cohort,
            severity: severity,
            errorMessage: errorMessage,
            isActiveExperiment: isActiveExperiment,
            product: product,
            detailedSource: source,
            ...additionalAttributes
        },
        tags: [
            (0, $gwZbZ.EVENT_TAG_GROWTH)
        ]
    };
};
module.exports["createEventPayload"] = $d2a9f5f63821177b$export$f2a94361d01a626c;

});

parcelRegister("3HIy9", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $8hmrm = parcelRequire("8hmrm");

const $de70a0c4deb210a2$export$d5090ca98c07c12d = (payload)=>{
    const { data: data } = payload;
    return {
        action: data.action,
        actionSubject: data.actionSubject,
        source: data.source,
        actionSubjectId: data.actionSubjectId,
        tags: data.tags
    };
};
const $de70a0c4deb210a2$export$2144cc21b87dd554 = (payload)=>{
    const { data: data } = payload;
    const eventName = `${data.actionSubject} ${data.action}`;
    return {
        eventName: eventName,
        attributes: data.attributes
    };
};
const $de70a0c4deb210a2$export$f106561f47f05126 = (event)=>{
    const { payload: payload } = event;
    // Extract attributes from the event payload and create a formatted payload
    // specifically for Jira product integration
    const analyticsEventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
        product: (0, $gwZbZ.Product).JIRA,
        team: payload.attributes.team,
        experimentMeta: {
            experimentKey: payload.attributes.experimentKey,
            cohort: payload.attributes.cohort
        },
        errorType: payload.attributes.errorType,
        errorMessage: payload.attributes.errorMessage,
        source: payload.attributes.source,
        severity: payload.attributes.severity
    });
    // Return both payload formats needed for complete Jira analytics integration:
    // 1. createEventPayload: Used with Jira's createAnalyticsEvent
    // 2. fireEventPayload: Used with Jira's fireEvent
    return {
        createEventPayload: $de70a0c4deb210a2$export$d5090ca98c07c12d(analyticsEventPayload),
        fireEventPayload: $de70a0c4deb210a2$export$2144cc21b87dd554(analyticsEventPayload)
    };
};
module.exports["convertEventPayloadForJiraCreateAnalyticsEvent"] = $de70a0c4deb210a2$export$d5090ca98c07c12d;
module.exports["convertEventAttributesForJiraFireEvent"] = $de70a0c4deb210a2$export$2144cc21b87dd554;

});

parcelRegister("39G0n", function(module, exports) {
/**
 * Validates that an experiment name doesn't contain spaces.
 * Experiment names with spaces can cause issues in dashboards and analytics tracking.
 *
 * @param experimentName The experiment name to validate
 * @throws Error if experiment name contains spaces
 */ const $34ecc222054f7431$export$7fa6b5da621cbeb2 = (experimentName)=>{
    if (experimentName.includes(' ')) throw new Error(`Experiment name "${experimentName}" contains spaces. ` + 'Experiment names must not contain spaces to ensure proper tracking in dashboards. ' + 'Use camelCase or hyphens instead (e.g., "myExperiment" or "my-experiment").');
};
module.exports["validateExperimentName"] = $34ecc222054f7431$export$7fa6b5da621cbeb2;

});

parcelRegister("6o7wX", function(module, exports) {
/**
 * Enumeration of authorized teams for growth error analytics
 *
 * IMPORTANT: If your team wants to use growth-commons-error-analytics:
 * 1. Add your team name following the convention 'TEAM_NAME = team-name'
 * 2. Create a PR and request review from the #growth-luna channel
 * 3. Provide context about your team and use case in the PR description
 *
 * The growth-luna team reviews all additions to maintain analytics quality
 * and ensure proper integration with dashboards.
 *
 * @example
 * // Adding a new team:
 * // GROWTH_NEW_TEAM = 'growth-new-team', // requires approval
 */ var $7d6dde24ede24951$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["GROWTH_LUNA"] = "growth-luna";
    return Team;
}({});
module.exports["Team"] = $7d6dde24ede24951$export$3e5d0af8e738b082;

});

parcelRegister("gj7hi", function(module, exports) {
$parcel$export(module.exports, "default", () => $df095e8eefdd8265$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cv8Bu = parcelRequire("cv8Bu");


var $cOrQJ = parcelRequire("cOrQJ");

const $df095e8eefdd8265$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $df095e8eefdd8265$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $42omo.useRef)(null);
    const providedColorMode = (0, $cv8Bu.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $cOrQJ.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $42omo.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $gMc0m.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});

parcelRegister("cv8Bu", function(module, exports) {
/* theme-provider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");


var $8z9j5 = parcelRequire("8z9j5");

var $hY0xh = parcelRequire("hY0xh");

var $bRSdj = parcelRequire("bRSdj");

var $60yhz = parcelRequire("60yhz");

const $d32a212d6e794c84$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: 'typography'
    });
const $d32a212d6e794c84$var$ColorModeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$SetColorModeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$ThemeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$SetThemeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined); /**
                                                                                                  * __UNSAFE_useColorModeForMigration()__
                                                                                                  *
                                                                                                  * Returns the current color mode when inside the app provider.
                                                                                                  * Unlike useColorMode, this utility returns undefined, instead of throwing an error, when the app provider is missing.
                                                                                                  * This allows it to be used by components that need to operate with and without an app provider.
                                                                                                  */ 
function $d32a212d6e794c84$export$ce91654eb9fea460() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$ColorModeContext);
    return value;
} /**
   * __useColorMode()__
   *
   * Returns the current color mode when inside the app provider.
   */ 
function $d32a212d6e794c84$export$20f3076712c8dfa() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$ColorModeContext);
    const { colorMode: colorMode } = (0, $8z9j5.default)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $42omo.useState)(colorMode || 'light');
    (0, $42omo.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $60yhz.default)((theme)=>{
            setResolvedColorMode(theme.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}
function $d32a212d6e794c84$export$e2afe7397c3d11c7() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
} /**
   * __useTheme()__
   *
   * Returns the current theme settings when inside the app provider.
   */ 
function $d32a212d6e794c84$export$93d4e7f90805808f() {
    const theme = (0, $42omo.useContext)($d32a212d6e794c84$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $42omo.useState)(theme || (0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $60yhz.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return theme ? theme : resolvedTheme;
} /**
   * __useSetTheme()__
   *
   * Returns the theme setter when inside the app provider.
   */ 
function $d32a212d6e794c84$export$501aa0dcd5527a48() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $d32a212d6e794c84$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $d32a212d6e794c84$var$prefersDarkModeMql = $d32a212d6e794c84$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined; // TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $d32a212d6e794c84$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $d32a212d6e794c84$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
const $d32a212d6e794c84$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $d32a212d6e794c84$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $42omo.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $42omo.useState)($d32a212d6e794c84$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $42omo.useState)(()=>({
            ...$d32a212d6e794c84$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $42omo.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($d32a212d6e794c84$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $42omo.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        // If fg enabled avoid mounting themes
        if ((0, $dh538.fg)('platform-static-theme-loading')) return;
         /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ 
        const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $bRSdj.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!$d32a212d6e794c84$var$prefersDarkModeMql) return;
        const unbindListener = (0, $fFa3V.bind)($d32a212d6e794c84$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = (0, $hY0xh.default)({
        ...theme,
        colorMode: reconciledColorMode
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: (0, $dh538.fg)('platform-static-theme-loading') ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        "data-theme": attrs['data-theme'],
                        "data-color-mode": attrs['data-color-mode'],
                        className: (0, $gMc0m.default)([
                            $d32a212d6e794c84$var$contentStyles.body
                        ]),
                        children: children
                    }) : children
                })
            })
        })
    });
}
var $d32a212d6e794c84$export$2e2bcd8739ae039 = $d32a212d6e794c84$var$ThemeProvider;
module.exports["UNSAFE_useColorModeForMigration"] = $d32a212d6e794c84$export$ce91654eb9fea460;

});


//# sourceMappingURL=base-component.3921ddeb.js.map
